import { EsriGraphicsLayer } from 'src/app/config/esri.module';
import { MainMapService } from 'src/app/shared/service/main-map.service';
import { Injectable } from '@angular/core';

@Injectable()
export class SketchService {
  private _sketchLayer: __esri.GraphicsLayer;

  constructor(private _mainMapService: MainMapService) {
    this._sketchLayer = new EsriGraphicsLayer();
    this._mainMapService.mapView.map.add(this.sketchLayer);
  }

  public removeAll(): void {
    this._sketchLayer.removeAll();
  }

  public get sketchLayer(): __esri.GraphicsLayer {
    return this._sketchLayer;
  }
}
